// extracted by mini-css-extract-plugin
module.exports = {"active":"#7dc12f","inactive":"#f6423a","primary":"#ff5b1c","header2Height":"60px","header3Height":"60px"};